'use strict';

var DevicesView = require('main/devices');
var VideoView = require('main/video-view');

document.addEventListener('DOMContentLoaded', function () {
    DevicesView.init('#devices-page');
    VideoView.init('#device-video-page');
});
